import React from "react";
import "./component.css";
function Footer() {
  return (
    <div className="footer">
      <span className="epic-legal-text">
        © 2025 Nike, Inc. All Rights Reserved
      </span>
    </div>
  );
}

export default Footer;
